import React, { useEffect } from 'react';
import Sigma from 'sigma';
import { useSigma } from '@react-sigma/core';
import { EdgeAttributes, NodeAttributes } from './graphTypes';

type GraphSigma = Sigma<NodeAttributes, EdgeAttributes>;

// mirrors the live sigma instance onto a ref owned by the page: the export
// buttons in GraphHeader sit outside SigmaContainer (in the static header,
// above the canvas), so they can't call useSigma() directly like
// GraphHoverEffects does
export const SigmaRefSync: React.FC<{ sigmaRef: React.MutableRefObject<GraphSigma | null> }> = ({ sigmaRef }) => {
  const sigma = useSigma<NodeAttributes, EdgeAttributes>();

  useEffect(() => {
    sigmaRef.current = sigma;
    return () => {
      sigmaRef.current = null;
    };
  }, [sigma, sigmaRef]);

  return null;
};
